<template>
    <div class="comment_write">
        <textarea placeholder="댓글 작성시 타인에 대한 배려와 존중이 필요합니다."
            name="wr_content"
            id="wr_content"
            v-model.trim="comment"
            @click="ckAuth"
        ></textarea>        
        <div class="comment_btn">        
            <button class="btn_basic btn_red btn_upload" @click="registerComment()">댓글등록</button>
        </div>
    </div>
</template>
<script>
export default {
    props:[
        'postid','ccommentId','ccommentUserId'
    ],   
    data(){
        return {
            comment:''
        }
    },
    computed:{
        isAuth(){
            return this.$store.getters.isAuthenticated;
        }
    },
    methods: {     
        ckAuth(){           
            if(!this.isAuth)
            {
                let result = confirm("로그인이 필요합니다.");
                if(result){
                    //this.$router
                    this.$router.push({ name: 'auth_login'});
                    return;
                }else{  
                    return;
                }
            }
        },
        registerComment(){          
            if (this.comment==="") {
                alert("내용을 입력해주세요");
                return;
            }            
            let formData = new FormData();
            formData.append("user_id", this.$store.getters.currentUser.id);
            //formData.append("user_id", 1);
            formData.append("post_id", this.postid);
            formData.append("body", this.comment);  
            if(this.ccommentUserId)
            {
                formData.append("comment_user_id", this.ccommentUserId);  
            }
           
            if(this.ccommentId)
            {
                formData.append("comment_id", this.ccommentId);  
            }          
            formData.append("comment_sort", this.$store.state.posts.commentSort);  

            this.$emit("save-comment", formData);   
            this.comment ='' 
        }
    },      
}
</script>
<style lang="scss" scoped>
.comment_write{
    border: 1px solid #dee3eb;
    textarea{
        overflow-y: auto;
        display: block;
        width: 100%;
        height: 135px;
        padding: 18px;
        border: 0;
        box-sizing: border-box;
        resize: none;
        line-height: 1.6em;
        font-size:12px;
        white-space: pre-line;
    }
    .comment_btn{
        height: 51px;
        background: #fafafa;
        border-top: 1px solid #ebeef3;
        display:flex;
        justify-content: flex-end;
    }
}
</style>